<div class="container m-3">
  <div *ngIf="hasWriteAccess" class="action-bar">
    <p-button
      pRipple
      (onClick)="onPostAnnouncement()"
      [disabled]="isFetching"
      class="flex flex-1 justify-content-end"
      icon="pi pi-megaphone"
      label="Post New Announcement"
    />
  </div>
  <div class="card" style="overflow: auto">
    <p-accordion *ngIf="announcements.length > 0" [multiple]="true" [activeIndex]="[0]">
      <p-accordionTab *ngFor="let tab of announcements">
        <ng-template pTemplate="header">
          <div class="header-container">
            <div>
              <span class="flex align-items-center gap-2 w-full">
                <span class="font-bold white-space-nowrap">
                  {{ tab.title }}
                </span>
              </span>
            </div>
            <div>
              <span class="posted-date">{{ tab.created | date : 'mediumDate' }}</span>
            </div>
          </div>
        </ng-template>
        <div class="content-container">
          <!-- <quill-view *ngIf="tab.content.length > 0; else emptyContent" [content]="tab.content" [sanitize]="true"></quill-view> -->
          <app-rich-text-editor
            *ngIf="tab.content.length > 0; else emptyContent"
            [content]="decodeContent(tab.content)"
            [readOnly]="true"
          ></app-rich-text-editor>

          <ng-template #emptyContent> <span class="empty-content"> No content found! </span></ng-template>
          <div *ngIf="hasWriteAccess" class="action-bar mb-2">
            <p-button label="Edit" icon="pi pi-pencil" [outlined]="true" severity="info" size="small" (onClick)="onPostAnnouncement(tab)" />
            <p-button label="Delete" icon="pi pi-trash" [outlined]="true" severity="danger" size="small" (onClick)="onDeleteAnnouncement(tab)" />
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
    <p *ngIf="!(announcements.length > 0)">No announcements found!</p>
  </div>
</div>

<system-announcement-sidebar *ngIf="showModal" [isAdd]="isAdd" [details]="selectedAnnouncement" [onClose]="onClose"></system-announcement-sidebar>

<app-delete-confirmation-modal
  *ngIf="showDeleteConfirmation"
  [deleteMsg]="deleteMsg"
  [onDelete]="onDeleteAnnouncement"
  [onCancel]="onClose"
></app-delete-confirmation-modal>
